import './App.css'
import Pages from "@/pages/index.jsx"
import {Toaster} from "sonner"
import {AuthFormProvider} from '@/context/AuthFormContext'
import {AuthProvider} from '@/context/AuthContext'
import {JobSearchProvider} from '@/context/JobSearchContext';
import SentryTest from '@/components/debug/SentryTest'
import CookieBanner from "@/components/banners/CookieBanner"

function App() {
  return (
    <AuthProvider>
      <AuthFormProvider>
          <JobSearchProvider>
              <Pages/>
              <Toaster position="top-center"/>
              <CookieBanner/>

              {/* Add the Sentry test component in non-production environments */}
              {['dev'].includes(import.meta.env.VITE_ENV) && <SentryTest/>}
          </JobSearchProvider>
      </AuthFormProvider>
    </AuthProvider>
  )
}

export default App 